import script from "./NavbarSpmi.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarSpmi.vue?vue&type=script&setup=true&lang=js"

import "./NavbarSpmi.vue?vue&type=style&index=0&id=631105ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631105ec"]])

export default __exports__